/**
 * GA4 constants (task 26).
 *
 * PROD_APP_HOSTNAME is the one host that reports without debug_mode.
 * Everything else (npm start, a dev deploy, a preview) is debug traffic,
 * which GA4 shows in DebugView.
 */
export const PROD_APP_HOSTNAME = 'app.gopropwise.com';

/** The gtag.js loader. The CSP allows this host in script-src. */
export const GA_SCRIPT_BASE = 'https://www.googletagmanager.com/gtag/js';
